import { APIEndpoint } from '../stores/apiStore'

export const API_ENDPOINTS: APIEndpoint[] = [
  {
    id: 'offers',
    name: 'Moments API',
    method: 'POST',
    path: '/native/v2/offers.json',
    description: 'Deliver relevant perks at key customer journey moments to boost loyalty and engagement',
    category: 'Moments',
    requiresAuth: true,
    samplePayload: {
      placement: "checkout_confirmation_page",
      ua: "Mozilla/5.0 (Linux; Android 10; K) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.6099.43 Mobile Safari/537.36",
      ip: "192.168.1.1",
      adpx_fp: "1234abcd-5678-efgh-9101-ijklmnopqrst",
      pub_user_id: "1234abcd-5678-efgh-9101-ijklmnopqrst",
      dev: "0",
      membershipID: "A45GRE987343PKD"
    },
    headerParameters: [
      {
        name: 'Content-Type',
        type: 'string',
        required: true,
        description: 'Should be application/json',
        example: 'application/json'
      }
    ],
    queryParameters: [
      {
        name: 'api_key',
        type: 'string',
        required: true,
        description: 'Your API Key. Obtain your API Key from the MomentScience dashboard. Required Permission: Ads/Offers',
        example: 'b9a31935-a222-4bdd-bfc6-a63e6bb01e39'
      },
      {
        name: 'loyaltyboost',
        type: 'string',
        required: false,
        description: 'Include LoyaltyBoost offers in response. Values: 0 = None, 1 = True, 2 = Only',
        example: '0'
      },
      {
        name: 'creative',
        type: 'string',
        required: false,
        description: 'Returns Offers with at least one creative (image) if set to true. Values: 0 or 1',
        example: '1'
      },
      {
        name: 'campaignId',
        type: 'string',
        required: false,
        description: 'Filters the response to return the single offer associated with the specified campaignId. Only one campaign ID can be used per request.',
        example: '3110'
      }
    ],
    parameters: [
      {
        name: 'placement',
        type: 'string',
        required: false,
        description: 'An attribute that represents the specific page, section, or location where the Offer Unit was triggered. This parameter enables enhanced reporting, analytics, and traffic segmentation.',
        example: 'checkout_confirmation_page'
      },
      {
        name: 'ua',
        type: 'string',
        required: false,
        description: 'The User-Agent of the end-user required for proper targeting. If proxying requests via a server call, be sure to pass through the User-Agent of the end-user.',
        example: 'Mozilla/5.0 (Linux; Android 10; K) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.6099.43 Mobile Safari/537.36'
      },
      {
        name: 'ip',
        type: 'string',
        required: false,
        description: 'IP address of the end user to be passed through. Used for targeting.',
        example: '192.168.1.1'
      },
      {
        name: 'adpx_fp',
        type: 'string',
        required: false,
        description: 'A unique identifier for the end user; Not required but highly recommended. Used for frequency capping and user exclusion.',
        example: '1234abcd-5678-efgh-9101-ijklmnopqrst'
      },
      {
        name: 'pub_user_id',
        type: 'string',
        required: false,
        description: 'A unique, non-PII identifier for the end user. Required when integrating with PerksWallet-as-a-Service (PWaaS) or User Selected Perks. This value links offers to individual users and must remain consistent across sessions and devices.',
        example: '1234abcd-5678-efgh-9101-ijklmnopqrst'
      },
      {
        name: 'dev',
        type: 'string',
        required: false,
        description: 'Returns a test response. Ignores geo restrictions. No activity is recorded. Values: 0 (disabled) or 1 (enabled)',
        example: '0'
      },
      {
        name: 'membershipID',
        type: 'string',
        required: false,
        description: 'Custom Key-Value payload attribute. You can add any number of custom key-value payload attributes to the payload that you want to use to add additional details.',
        example: 'A45GRE987343PKD'
      }
    ]
  },
  {
    id: 'perkswall',
    name: 'Perkswall API',
    method: 'POST',
    path: '/native/v4/perkswall.json',
    description: 'Retrieve perkswall offers and rewards',
    category: 'Perks',
    requiresAuth: true,
    samplePayload: {
      placement: "checkout_confirmation_page",
      ua: "Mozilla/5.0 (Linux; Android 10; K) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.6099.43 Mobile Safari/537.36",
      ip: "192.168.1.1",
      adpx_fp: "1234abcd-5678-efgh-9101-ijklmnopqrst",
      dev: "0",
      subid: "mobile_android_app_post_transaction",
      pub_user_id: "1234abcd-5678-efgh-9101-ijklmnopqrst"
    },
    queryParameters: [
      {
        name: 'api_key',
        type: 'string',
        required: true,
        description: 'Your API Key. Obtain your API Key from the MomentScience dashboard. Required Permission: Ads/Offers',
        example: 'b9a31935-a222-4bdd-bfc6-a63e6bb01e39'
      },
      {
        name: 'loyaltyboost',
        type: 'string',
        required: false,
        description: 'Include LoyaltyBoost offers in the response. 0 = Do not include LoyaltyBoost Offers, 1 = Include LoyaltyBoost Offers, 2 = Return only LoyaltyBoost Offers',
        example: '0'
      },
      {
        name: 'creative',
        type: 'string',
        required: false,
        description: 'Returns offers with at least one creative (image) if set to 1. 0 = False, 1 = True',
        example: '1'
      }
    ],
    parameters: [
      {
        name: 'placement',
        type: 'string',
        required: false,
        description: 'An attribute that represents the specific page, section, or location where the Offer Unit was triggered. This parameter enables enhanced reporting, analytics, and traffic segmentation.',
        example: 'checkout_confirmation_page'
      },
      {
        name: 'ua',
        type: 'string',
        required: false,
        description: 'The User-Agent string of the end-user, required for proper targeting. If proxying requests via a server, ensure the User-Agent of the end-user is passed through.',
        example: 'Mozilla/5.0 (Linux; Android 10; K) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.6099.43 Mobile Safari/537.36'
      },
      {
        name: 'ip',
        type: 'string',
        required: false,
        description: 'The IP address of the end user for targeting purposes.',
        example: '192.168.1.1'
      },
      {
        name: 'adpx_fp',
        type: 'string',
        required: false,
        description: 'A unique identifier for the end user. This is not required, but highly recommended for accurate tracking.',
        example: '1234abcd-5678-efgh-9101-ijklmnopqrst'
      },
      {
        name: 'dev',
        type: 'string',
        required: false,
        description: 'Enables a test response. When set to 1, the sandbox environment is activated, allowing for testing without recording any activity in production. In this mode, geo-restrictions are ignored, and all Offers are returned in the response, providing a comprehensive testing experience. Set to 1 to enable test mode.',
        example: '0'
      },
      {
        name: 'subid',
        type: 'string',
        required: false,
        description: 'An ID used to identify specific usages of the Fetch Perkswall Offers API.',
        example: 'mobile_android_app_post_transaction'
      },
      {
        name: 'pub_user_id',
        type: 'string',
        required: false,
        description: 'A unique, non-PII identifier for the end user. Required when integrating with PerksWallet-as-a-Service (PWaaS) or User Selected Perks. This value links offers to individual users and must remain consistent across sessions and devices. You may use the same value as adpx_fp, if available. Do not use personally identifiable information (PII), such as email addresses or phone numbers.',
        example: '1234abcd-5678-efgh-9101-ijklmnopqrst'
      }
    ]
  },
  {
    id: 'catalog',
    name: 'Offer Catalog API',
    method: 'GET',
    path: '/native/v3/catalog.json',
    description: 'Browse available offer catalog',
    category: 'Catalog',
    requiresAuth: true,
    queryParameters: [
      {
        name: 'api_key',
        type: 'string',
        required: true,
        description: 'Your API Key. Obtain your API Key. Required Permission: Ads/Offers',
        example: '4bbdefc2-b130-424d-8170-54bdcb98e64e'
      },
      {
        name: 'offer_id',
        type: 'string',
        required: false,
        description: 'If provided, the response will only return data related to that specific Offer',
        example: '1651'
      },
      {
        name: 'countries',
        type: 'string',
        required: false,
        description: 'Specify ISO 3166-1 alpha-2 country code(s) to fetch Offers related to specific countries. Use a 2-character country code (e.g., US). You can add multiple values and separate them with commas (e.g., US,IN,EG)',
        example: 'US,IN,EG'
      },
      {
        name: 'os',
        type: 'string',
        required: false,
        description: 'Specify the targeted operating systems for Offers. Supported values include windows, macos, android, and ios. You can add multiple values and separate them with commas (e.g., ios,android)',
        example: 'ios,android'
      },
      {
        name: 'platforms',
        type: 'string',
        required: false,
        description: 'Specify the targeted platforms for Offers. Supported values include desktop, phone, and tablet. You can add multiple values and separate them with commas (e.g., tablet,phone)',
        example: 'tablet,phone'
      },
      {
        name: 'browsers',
        type: 'string',
        required: false,
        description: 'Specify the targeted web browsers for Offers. Supported values include edge, chrome, firefox, safari, and opera. You can add multiple values and separate them with commas (e.g., chrome,firefox)',
        example: 'chrome,firefox'
      }
    ],
    parameters: [
      {
        name: 'account_id',
        type: 'string',
        required: true,
        description: 'Your MomentScience account identifier',
        example: '12345'
      },
      {
        name: 'category',
        type: 'string',
        required: false,
        description: 'Filter by offer category',
        example: 'retail'
      },
      {
        name: 'limit',
        type: 'number',
        required: false,
        description: 'Maximum number of offers to return',
        example: 50
      },
      {
        name: 'offset',
        type: 'number',
        required: false,
        description: 'Number of offers to skip for pagination',
        example: 0
      }
    ]
  },
  {
    id: 'reporting',
    name: 'Reporting API',
    method: 'GET',
    path: '/native/activity.json',
    description: 'Access analytics and reporting data',
    category: 'Analytics',
    requiresAuth: true,
    queryParameters: [
      {
        name: 'api_key',
        type: 'string',
        required: true,
        description: 'Your API Key. Obtain your API Key. Required Permission: Reports',
        example: '4bbdefc2-b130-424d-8170-54bdcb98e64e'
      },
      {
        name: 'from',
        type: 'string',
        required: false,
        description: 'Specify the date (YYYY-MM-DD format) for which you want to retrieve reports. It will retrieve data for only 24 hours starting from the specified date\'s beginning. Default: Yesterday\'s Date (beginning of the day)',
        example: '2024-03-20'
      },
      {
        name: 'aggregated_by',
        type: 'string',
        required: false,
        description: 'Choose between \'day\' or \'hour\' to segment activity on a daily or hourly basis. Default: \'day\'',
        example: 'hour'
      }
    ],
    parameters: [
      {
        name: 'account_id',
        type: 'string',
        required: true,
        description: 'Your MomentScience account identifier',
        example: '12345'
      },
      {
        name: 'start_date',
        type: 'string',
        required: false,
        description: 'Start date for reporting period (YYYY-MM-DD)',
        example: '2024-01-01'
      },
      {
        name: 'end_date',
        type: 'string',
        required: false,
        description: 'End date for reporting period (YYYY-MM-DD)',
        example: '2024-12-31'
      },
      {
        name: 'metrics',
        type: 'array',
        required: false,
        description: 'Specific metrics to include in report',
        example: ['clicks', 'conversions', 'revenue']
      }
    ]
  }
]

export const COMMON_HEADERS = [
  { key: 'Content-Type', value: 'application/json' },
  { key: 'Authorization', value: 'Bearer YOUR_API_KEY' },
  { key: 'Accept', value: 'application/json' },
  { key: 'User-Agent', value: 'MomentScience-API-Explorer/1.0' },
  { key: 'X-Requested-With', value: 'XMLHttpRequest' }
]
